import React, { useState } from 'react';
import SideNav, {
  SideNavMenu,
  SideNavItem,
  SideNavFooter,
} from '@bexs/dollar/components/SideNav';
import { SvgContract, SvgCapital, SvgLogout } from '@bexs/dollar-icons';
import { useHistory, useLocation } from 'react-router-dom';
import { SideNavItemProps } from '@bexs/dollar/components/SideNav/types';
import { useDispatch } from 'react-redux';
import { deleteToken } from 'client/utils/token';
import { logout as logoutAction } from 'store/ducks/auth/actions';
import { SideNavLink, LogoutBtn } from './styles';
import { colors } from '../../styles/colors';

const ROUTE_LIST = [
  {
    path: '/balance',
    text: 'Balance',
    icon: <SvgCapital />,
  },
  {
    path: '/reports',
    text: 'Reports',
    icon: <SvgContract />,
  },
];

type LinkProps = SideNavItemProps & {
  className: string;
};

const Sidebar: React.FC = () => {
  const dispatch = useDispatch();

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);
  const location = useLocation();
  const history = useHistory();

  const logout = () => {
    deleteToken();
    dispatch(logoutAction());
    history.push('/');
  };

  const CustomLink = (props: LinkProps) => {
    const { children, to, className } = props;

    const isCurrent = location.pathname === to;
    const activeStyle = isCurrent
      ? { color: `var(${colors['primary/1000']})` }
      : {};

    return (
      <SideNavLink to={to as string} className={className} style={activeStyle}>
        {children}
      </SideNavLink>
    );
  };

  const LogoutButton = (props: LinkProps) => {
    const { className, children } = props;
    return (
      <LogoutBtn type="button" className={className} onClick={logout}>
        {children}
      </LogoutBtn>
    );
  };

  return (
    <SideNav
      isOpen={isSidebarOpen}
      overlayOnMobile
      color="light"
      onClose={() => setIsSidebarOpen(false)}
      customLogo="https://storage.googleapis.com/bexs-forex-static/images/ebury-bank-logo-black-horizontal.png"
    >
      <SideNavMenu>
        {ROUTE_LIST.map(({ text, path, icon }) => (
          <SideNavItem
            as={CustomLink}
            to={path}
            key={path}
            isSelected={location.pathname === path}
          >
            {icon}
            {text}
          </SideNavItem>
        ))}
      </SideNavMenu>
      <SideNavFooter>
        <SideNavItem as={LogoutButton}>
          <SvgLogout />
          Logout
        </SideNavItem>
      </SideNavFooter>
    </SideNav>
  );
};

export default Sidebar;
